import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.webp';
import crossfitKid from '../../assets/crossfit-kids.webp';
import crossfit from '../../assets/crossfit.webp';
import aics from '../../assets/aics.png';
import hyrox from '../../assets/hyrox.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';



export default function FooterBlock() {

    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <Container fluid className='p-3 text-white' id="footer">
                <Container fluid='md'>
                    <a href="/Codici_condotta_definitivo.pdf" target='_blank'><Button>Codice Condotta</Button></a>
                    <a className="ms-3" href="/mog.pdf" target='_blank'><Button>M.O.G.</Button></a>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <h4>Gate 51</h4>
                            <div className='footer-widget pt-3'>
                                <p>
                                    Viale venezia, 51,<br />
                                    San vendemiano (TV), 31020<br />
                                    Italia
                                </p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <h4>Contatti</h4>
                            <div className='footer-widget pt-3'>
                                <p>
                                    <i>Info</i>: <b><a className="link-light" href="mailto:crossfitgate51@gmail.com">crossfitgate51@gmail.com</a></b><br />
                                    <i>Tel</i>: <b><a className="link-light" href="tel:3755035466">3755035466</a></b><br />
                                    Lasciaci un messaggio,<br/>ti risponderemo il prima possibile.
                                </p>

                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <h4>Certificates</h4>
                            <div className='footer-widget pt-3'>
                                <p>
                                    <span className='me-3'>
                                        <Image style={{ filter: 'invert(1)' }} src={crossfit} width={70} />
                                    </span>
                                    <span className='me-3'>
                                        <Image src={hyrox} width={70} />
                                    </span>
                                    <span className='me-3'>
                                        <Image src={crossfitKid} width={70} />
                                    </span>
                                    <span className='me-3'>
                                        <Image src={aics} width={70} />
                                    </span>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid='md' className='mt-5 text-center'>
                    <p className='text-secondary'>© 2025 Gate 51. | P.iva 04981130265 | C.F. 91046400262</p>
                </Container>
            </Container>

            {/* Scroll to Top Button */}
            {showScrollTop && (
                <Button
                    onClick={scrollToTop}
                    style={{
                        position: 'fixed',
                        bottom: '30px',
                        right: '30px',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        backgroundColor: '#ffc107',
                        border: 'none',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#ffb300';
                        e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ffc107';
                        e.currentTarget.style.transform = 'scale(1)';
                    }}
                >
                    <FontAwesomeIcon icon={faArrowUp} size="lg" color="#000" />
                </Button>
            )}
        </>
    );
};